import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton, Tooltip,
} from '@material-ui/core';
import FindInPageIcon from '@material-ui/icons/FindInPage';
// import { withPermissionsChecker } from 'wrappers';


/**
 * This component allows to render a button specific to find in modal.
 * @param {*} param0
 */
const FindButton = ({
  onClick,
}) => (
  <IconButton
    onClick={onClick}
  >
    <Tooltip title="Filtros avanzados">
      <FindInPageIcon />
    </Tooltip>
  </IconButton>
);

FindButton.propTypes = {
  onClick: PropTypes.func,
};

// export default withPermissionsChecker(FindButton);
export default FindButton;
